import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import styles from "./../tooltip.module.css";
import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";
import "../Productos/productosTable.css";
import "./../htmlTable.css";

import * as api from "helper/helper";
import SearchBar from "../SearchBar";

import { PermissionsForSection } from "../auth";

import { Sections } from "../../data/navItem";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import PedidosEspecialesTable from "./PedidosEspecialesTable";
import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
import CreatePedidoEspecial from "./CreatePedidoEspecial";
import { buildNameWithId, Singleton } from "helper/tools";
import ExportCSV from "../ExportCSV";
import { format } from "date-fns";
/*
function SectionOption(id = "", title = "", isSelected = false) {
  this.id = id;
  this.title = title;
  this.isSelected = isSelected;
}*/

function PedidosEspecialesCatalogo({ subSectionId }) {
  const Menus = {
    Proveedor: 0,
    Marca: 1,
    Genero: 2,
    CategoriaCompra: 3,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const createProveedorRef = useRef();
  const filtrosRef = useRef([]);

  const csvRef = useRef();
  //const proveedoresRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [proveedores, setProveedores] = useState([]);

  const [productos, setProductos] = useState([]);

  const [marcas, setMarcas] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [categoriasCompras, setCategoriasCompras] = useState([]);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });
  /*
  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);*/

  const [filtros, setFiltros] = useState([
    /*  { type: Menus.Marca, name: "Marca" },
    { type: Menus.Tags, name: "Etiquetado con" },*/
    {
      type: Menus.Proveedor,
      name: "Proveedor",
    },
    {
      type: Menus.Marca,
      name: "Marca",
    },
    {
      type: Menus.Genero,
      name: "Genero",
    },
    {
      type: Menus.CategoriaCompra,
      name: "Categoria Compra",
    },
    /* { type: "add_filter", name: "Agregar filtro" },*/
  ]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async () => {
    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    const responseProveedores = await api.proveedores().catch((error) => {
      toast.error("Error al pedir Proveedores.");
      setIsLoading(false);
    });

    if (!responseProveedores) return;

    const autoAsociados = responseProveedores.data.map((item) => {
      const text = buildNameWithId(item, item.numProveedor);
      return { id: item.id, nombre: text };
    });
    setProveedores(autoAsociados);
  };

  const fetchCatalogos = async () => {
    setIsLoading(true);
    const responseMarcas = await api.marcas().catch((error) => {
      toast.error("Error al pedir marcas.");
      setIsLoading(false);
    });
    if (!responseMarcas) return;

    setMarcas(responseMarcas.data);

    const responseGeneros = await api.generos().catch((error) => {
      toast.error("Error al pedir generos.");
      setIsLoading(false);
    });
    if (!responseGeneros) return;

    setGeneros(responseGeneros.data);

    const responseCategoriasCompras = await api
      .categoriasCompras()
      .catch((error) => {
        toast.error("Error al pedir generos.");
        setIsLoading(false);
      });
    if (!responseCategoriasCompras) return;

    setCategoriasCompras(responseCategoriasCompras.data);

    setFiltros([...filtros]);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
    fetchCatalogos();

    const newPermissions = PermissionsForSection(Sections.Productos);
    setPermissions(newPermissions);
  }, []);

  function createProducto(event) {
    console.log(event);
    loadItem({});
  }

  function reloadProveedores() {
    fetchData();
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    setModalData(item);

    createProveedorRef.current.toggleModal();
  }

  /**
   * Search handler
   */

  const handleOnChange = (value, item) => {
    console.log("-->");

    let criteria = searchCriteria;
    let tagIds = [];
    let name = "";

    if (value != null && value.id != null) {
      tagIds = criteria["marcaIds"] ?? [];
      let tagId = value.id;
      if (!tagIds.includes(tagId)) {
        tagIds.push(tagId);
      } else {
        tagIds = tagIds.filter((f) => f !== tagId);
      }

      name = value.value;
    }

    criteria["marcaIds"] = tagIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    if (item != null) {
      const index = filtros.findIndex((currItem) => {
        return currItem.type === item.type;
      });
      filtrosRef.current[index].toka(name);
      filtrosRef.current[index].hideMenu();
    }
  };

  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    criteria["texto"] = e;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Proveedor && item.type === value.type) {
        clearAutocompleteFilter(item);
        return;
      } else if (value.type === Menus.Marca && item.type === value.type) {
        clearMarcasFilter();
      } else if (value.type === Menus.Genero && item.type === value.type) {
        clearGenerosFilter();
      } else if (
        value.type === Menus.CategoriaCompra &&
        item.type === value.type
      ) {
        clearCategoriaCompraFilter();
      }
    });
  }

  const handleMarcaClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["marcaIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateMarcasCriteria(nivelIds);
  };

  const updateMarcasCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["marcaIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Marca;
    });

    if (index === -1) {
      return;
    }
    var marcasNames = "";
    if (nivelIds.length > 0) {
      //
      const marcasFilter = marcas.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      marcasNames = marcasFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(marcasNames);
  };

  const handleGeneroClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["generoIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateGenerosCriteria(nivelIds);
  };

  const updateGenerosCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["generoIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Genero;
    });

    if (index === -1) {
      return;
    }
    var generosNames = "";
    if (nivelIds.length > 0) {
      //
      const generosFilter = generos.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      generosNames = generosFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(generosNames);
  };

  const handleCategoriaComprasClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["CategoriaCompraIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateCategoriaComprasCriteria(nivelIds);
  };

  const updateCategoriaComprasCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["CategoriaCompraIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CategoriaCompra;
    });

    if (index === -1) {
      return;
    }
    var categoriasComprasNames = "";
    if (nivelIds.length > 0) {
      //
      const categoriasComprasFilter = categoriasCompras.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      categoriasComprasNames = categoriasComprasFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(categoriasComprasNames);
  };

  const clearAutocompleteFilter = (item) => {
    handleOnChange(undefined, item);
  };

  const clearMarcasFilter = () => {
    marcas.forEach((item) => {
      item.checked = false;
    });

    setMarcas(marcas.slice());

    updateMarcasCriteria([]);

    filtrosRef.current[Menus.Marca].hideMenu();
  };

  const clearGenerosFilter = () => {
    generos.forEach((item) => {
      item.checked = false;
    });

    setGeneros(marcas.slice());

    updateGenerosCriteria([]);

    filtrosRef.current[Menus.Genero].hideMenu();
  };

  const clearCategoriaCompraFilter = () => {
    generos.forEach((item) => {
      item.checked = false;
    });

    setCategoriasCompras(categoriasCompras.slice());

    updateCategoriaComprasCriteria([]);

    filtrosRef.current[Menus.CategoriaCompra].hideMenu();
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);
    const response = await api
      .searchOrdenesComprasEspeciales(criteria)
      .catch((error) => {
        toast.error("Error al buscar Compras Especiales.");
        setIsLoading(false);
      });
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    setProductos(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados

    const csvString = [
      [
        "Id",
        "Proveedor",
        "Cantidad",
        "Nombre",
        "Marca",
        "Genero",
        "Costo",
        "Total Precio Costo",
        "Margen",
        "Precio Publico",
        "Total Precio Publico",
        "Categoria",
        "Fecha Orden",
      ], // Specify your headers here
      ...productos.map((item) => {
        const id = item.id;
        const costo = Singleton.getInstance().format(item.costo);
        const precioPublico = Singleton.getInstance().format(
          item.precioPublico,
        );
        const totalPrecioPublico = Singleton.getInstance().format(
          item.totalPrecioPublico,
        );
        const totalPrecioCosto = Singleton.getInstance().format(
          item.totalPrecioCosto,
        );
        const fechaOrden = format(item.fechaOrden, "dd/MM/yy");

        return [
          id,
          item.proveedor.nombre ?? "",
          item.cantidad ?? "",
          item.nombre ?? "",
          item.marca.nombre ?? "",
          item.genero.nombre ?? "",
          costo ?? "",
          totalPrecioCosto ?? "",
          item.margen ?? "",
          precioPublico ?? "",
          totalPrecioPublico ?? "",
          item.categoriaCompra.nombre,
          fechaOrden ?? "",
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "pedidosEspeciales.csv");
  }

  return (
    <>
      <ExportCSV ref={csvRef} />

      <div className="card recent-sales overflow-auto">
        <div className="separator"></div>
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className="header">
              <SearchBar
                onChange={(e) => onChangeSearchText(e)}
                placeholder="Buscar por Nombre..."
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginLeft: "0px" }}
                disabled={isLoading}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>
              <button
                className="btn btn-primary"
                onClick={createProducto}
                hidden={!permissions.canCreate}
              >
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Pedido Especial
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            >
              {filtros.map((item, index) => {
                return (
                  <>
                    <FilterButton
                      key={index}
                      item={item}
                      ref={(el) => (filtrosRef.current[index] = el)}
                      name={item.name}
                      clearCallback={(ble) => clearCallback(item)}
                    >
                      <ul
                        className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                        aria-labelledby="dropdownMenuClickableInside"
                      >
                        {item.type === Menus.Proveedor && (
                          <TableOptionCheck
                            key={index}
                            item={item}
                            filterType={FilterType.AutoComplete}
                            options={proveedores}
                            values={proveedores}
                            onChange={handleOnChange}
                          />
                        )}
                        {item.type === Menus.Marca &&
                          marcas.map((item, index) => {
                            return (
                              <TableOptionCheck
                                key={index}
                                item={item}
                                onClick={handleMarcaClick}
                              />
                            );
                          })}
                        {item.type === Menus.Genero &&
                          generos.map((item, index) => {
                            return (
                              <TableOptionCheck
                                key={index}
                                item={item}
                                onClick={handleGeneroClick}
                              />
                            );
                          })}
                        {item.type === Menus.CategoriaCompra &&
                          categoriasCompras.map((item, index) => {
                            return (
                              <TableOptionCheck
                                key={index}
                                item={item}
                                onClick={handleCategoriaComprasClick}
                              />
                            );
                          })}
                      </ul>
                    </FilterButton>
                  </>
                );
              })}
            </div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item) => {
              let page = pagingInfoRef.current.page;
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>

        <div className="card-body">
          <PedidosEspecialesTable
            items={productos}
            openItem={loadItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
          />
        </div>

        <CreatePedidoEspecial
          ref={createProveedorRef}
          item={modalData}
          reloadProveedor={reloadProveedores}
        />
      </div>
    </>
  );
}

export default PedidosEspecialesCatalogo;
